import { render, staticRenderFns } from "./popList.vue?vue&type=template&id=2d8d725e&scoped=true&"
import script from "./popList.vue?vue&type=script&lang=js&"
export * from "./popList.vue?vue&type=script&lang=js&"
import style0 from "./popList.vue?vue&type=style&index=0&id=2d8d725e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d725e",
  null
  
)

export default component.exports